import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  createGeoObject,
  getJSONFromString,
  getPointData,
  getPointOptions,
  getResponseError,
  setFormError,
} from '../../../utils/utils';
import { createStops, editStopsById } from '../actions';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import StopsDTO from '../../../dto/StopsDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import DatePicker from '../../../components/fields/DatePicker/DatePicker';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadGeographyList } from '../../Geography/actions';

export default function StopsForm(props) {
  const {
    handleClose = () => {},
    loadData = () => {},
    stop = null,
    mapInstance = null,
    geoObjects = [],
  } = props;
  const dispatch = useDispatch();
  const {
    reset, control, getValues, setError, setValue, watch,
  } = useForm({
    mode: 'onChange',
    defaultValues: stop || { status: 1 },
  });

  useEffect(() => {
    if (geoObjects?.length) {
      geoObjects[0].geometry.events.add('change', () => {
        const coordinates = geoObjects[0].geometry.getCoordinates();
        setValue('location', createGeoObject(coordinates));
      });

      return () => {
        geoObjects[0].geometry.events.remove('change');
      };
    }
  }, [geoObjects, mapInstance]);

  useEffect(() => {
    const subscription = watch(values => {
      if (values?.capacity?.scooter && typeof values.capacity.scooter !== 'undefined' && values?.capacity?.scooter !== values?.num_vehicles_available?.scooter) {
        setValue('num_vehicles_available.scooter', values.capacity.scooter);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    reset({});
    const coordinates = stop?.location?.geometry?.coordinates || getJSONFromString(process.env.REACT_APP_MAP_CENTER) || [];
    const marker = new window.ymaps.Placemark(coordinates, getPointData({}), getPointOptions({}, true));
    mapInstance.geoObjects.add(marker);
    const location = createGeoObject(coordinates);
    setTimeout(() => reset(stop ? new StopsDTO({ ...stop, location }).getData() : { location }), 100);
  }, [JSON.stringify(stop)]);

  const handleSave = () => {
    const values = new StopsDTO(getValues()).getData();
    const action = stop ? editStopsById({ ...values, id: stop.id }) : createStops(values);
    dispatch(action)
      .then(() => {
        successNotification('Сохранение данных', 'Данные сохранены');
        loadData();
        handleClose();
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение данных', getResponseError(response));
      });
  };

  const dto = new StopsDTO();
  const attributes = dto.getAttributesByName();

  return (
    <div className="list-columns card py-3 stop-form">
      <div className="list-header px-3 mb-3">
        <div className="fs-5 fw-semibold ">{stop ? 'Редактирование остановки' : 'Новая остановка'}</div>
        <Button className="small-button ms-auto" variant="second" onClick={handleClose}>
          <Icons customIcon icon="close" />
        </Button>
      </div>
      <div className="list-content-wrapper">
        <div className="list-content-body px-3">
          <div />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
            className="mb-3 mt-2"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={DatePicker}
            dtoObject={attributes.last_reported}
            variant="material"
            withLabel
            className="mb-3"
            changeFormat="x"
          />
          <FieldDTOWithCol
            control={control}
            type="number"
            component={TextInputWithLabel}
            dtoObject={{
              ...attributes.capacity,
              name: 'capacity.scooter',
            }}
            variant="material"
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            dtoObject={attributes.geography_id}
            usePortal
            addPlaceholder
            placeholder="Выбрать гео. объект"
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadGeographyList}
            optionFormatter={item => ({ value: item.geography_id, name: item.name })}
            filterName="full_name"
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.short_name}
            variant="material"
            className="mb-3 mt-2"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.address}
            variant="material"
            className="mb-3 mt-2"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.post_code}
            variant="material"
            className="mb-3 mt-2"
          />
          {/* <Row> */}
          {/*  <Col columns={12} className="text-end"> */}
          {/*    {!stop && !isDrawing ? ( */}
          {/*      <Button className="small-button" variant="second" onClick={handleDrawing}> */}
          {/*        <Icons icon="geo-alt" /> */}
          {/*      </Button> */}
          {/*    ) : null} */}
          {/*  </Col> */}
          {/* </Row> */}

        </div>
      </div>
      <div className="list-footer px-3 d-flex justify-content-around">
        <Button className="flex-sm-fill me-2" onClick={() => handleSave()}>{stop ? 'Сохранить' : 'Создать'}</Button>
        <Button className="flex-sm-fill ms-2" variant="secondary" onClick={handleClose}>Отменить</Button>
      </div>
    </div>
  );
}
